export default __webpack_public_path__ + "static/media/topright.2bb452d3.svg";